module.exports = __webpack_public_path__ + "static/media/DigitalHealth.f93834f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/newlogos/DigitalHealth.svg
// module id = 245
// module chunks = 0